import {
  CapaErrorCode,
  CapaPaymentCancelStatus,
  CapaPaymentMethodType,
  CapaPaymentStatus,
  CapaPurchaseOrderModel,
  CapaPurchaseOrderStatus,
  CapaQuotationServiceType,
  FetchMyPaymentDataByQuotationUserQuery
} from '@generated/graphql';
import { graphql } from 'msw';
import { v4 } from 'uuid';

export const fetchMyPaymentDataByQuotationUser = graphql.query<
  FetchMyPaymentDataByQuotationUserQuery
>('fetchMyPaymentDataByQuotationUser', (req, res, ctx) => {
  const { offset, limit } = req.variables.input;

  const purchaseOrderInfoList = [
    ...PaymentMangeModel.map((v) => ({
      ...v,
      purchaseOrderId: v.purchaseOrderId! + 1
    })),
    ...PaymentMangeModel.map((v) => ({
      ...v,
      purchaseOrderId: v.purchaseOrderId! + 2
    }))
  ].slice(offset ?? 0, offset + (limit ?? 5));

  return res(
    ctx.data({
      fetchMyPaymentDataByQuotationUser: {
        result: CapaErrorCode.Success,
        errorMessage: null,
        data: {
          completionAmount: 1,
          estimatedAmount: 1,
          purchaseOrderInfoList
        },
        __typename: 'CAPAQuotationPaymentManageModelOutput'
      }
    })
  );
});

const PaymentMangeModel: CapaPurchaseOrderModel[] = [
  {
    __typename: 'CAPAPurchaseOrderModel',
    purchaseOrderId: v4(),
    partnerOrganizationName: 'test',
    clientOrganizationName: null,
    purchaseOrderStatus: CapaPurchaseOrderStatus.CancelConfirmed,
    serviceType: CapaQuotationServiceType.Cnc,
    paymentManageModelList: [
      {
        thumbnailId: '1234',
        chatRoomId: '1234',
        id: v4(),
        confirmedAt: '',
        createdAt: '2022-06-15',
        isRead: false,
        quotationId: '',
        quotationPartnerId: '',
        quotationPartnerUserId: '',
        quotationUserId: '',
        rfqId: '1',
        status: CapaPaymentStatus.CancelFailed,
        totalAmount: 100000,
        paidAt: '2022-06-15',
        cancelAmount: null,
        cancelId: null,
        cancelReason: null,
        cancelStatus: null,
        commission: null,
        purchaseOrderId: 'null',
        updatedAt: null,
        virtualAccountId: null,
        hasReview: false,
        paymentMethod: CapaPaymentMethodType.CreditCard
      }
    ]
  },
  {
    __typename: 'CAPAPurchaseOrderModel',
    purchaseOrderId: v4(),
    partnerOrganizationName: 'test',
    clientOrganizationName: null,
    purchaseOrderStatus: CapaPurchaseOrderStatus.CancelConfirmed,
    serviceType: CapaQuotationServiceType.Cnc,
    paymentManageModelList: [
      {
        __typename: 'CAPAQuotationPaymentManageModel',
        paymentMethod: CapaPaymentMethodType.CreditCard,
        thumbnailId: '1234',
        chatRoomId: '1234',
        id: v4(),
        confirmedAt: '',
        createdAt: '2022-06-15',
        isRead: false,
        quotationId: '',
        quotationPartnerId: '',
        quotationPartnerUserId: '',
        quotationUserId: '',
        rfqId: '2',
        status: CapaPaymentStatus.CancelFailed,
        totalAmount: 100000,
        commission: 100,
        paidAt: '2022-06-15',
        cancelAmount: null,
        cancelId: null,
        cancelReason: null,
        cancelStatus: null,
        purchaseOrderId: 'null',
        updatedAt: null,
        virtualAccountId: null,
        hasReview: false
      }
    ]
  },
  {
    __typename: 'CAPAPurchaseOrderModel',
    purchaseOrderId: v4(),
    partnerOrganizationName: 'test',
    clientOrganizationName: null,
    purchaseOrderStatus: CapaPurchaseOrderStatus.CancelRequested,
    serviceType: CapaQuotationServiceType.Cnc,
    paymentManageModelList: [
      {
        __typename: 'CAPAQuotationPaymentManageModel',
        paymentMethod: CapaPaymentMethodType.CreditCard,
        thumbnailId: '1234',
        chatRoomId: '1234',
        id: v4(),
        confirmedAt: '',
        createdAt: '2022-06-15',
        paidAt: '2022-06-15',
        cancelAmount: null,
        cancelId: null,
        commission: null,
        purchaseOrderId: 'null',
        updatedAt: null,
        virtualAccountId: null,
        hasReview: false,
        isRead: false,
        quotationId: '',
        quotationPartnerId: '',
        quotationPartnerUserId: '',
        quotationUserId: '',
        rfqId: '3',
        status: CapaPaymentStatus.CancelFailed,
        totalAmount: 100000,
        cancelReason: '취소 대기 중',
        cancelStatus: CapaPaymentCancelStatus.CancelRequested
      }
    ]
  },
  {
    __typename: 'CAPAPurchaseOrderModel',
    purchaseOrderId: v4(),
    partnerOrganizationName: 'test',
    clientOrganizationName: null,
    purchaseOrderStatus: CapaPurchaseOrderStatus.CancelConfirmed,
    serviceType: CapaQuotationServiceType.Cnc,
    paymentManageModelList: [
      {
        __typename: 'CAPAQuotationPaymentManageModel',
        thumbnailId: '1234',
        chatRoomId: '1234',
        id: v4(),
        confirmedAt: '',
        createdAt: '2022-06-15',
        paidAt: '2022-06-15',
        cancelAmount: null,
        cancelId: null,
        cancelReason: null,
        cancelStatus: null,
        commission: null,
        purchaseOrderId: 'null',
        updatedAt: null,
        virtualAccountId: null,
        hasReview: false,
        isRead: false,
        quotationId: '',
        quotationPartnerId: '',
        quotationPartnerUserId: '',
        quotationUserId: '',
        rfqId: '4',
        status: CapaPaymentStatus.CancelFailed,
        totalAmount: 100000,
        paymentMethod: CapaPaymentMethodType.CreditCard
      }
    ]
  },
  {
    __typename: 'CAPAPurchaseOrderModel',
    purchaseOrderId: v4(),
    partnerOrganizationName: 'test',
    clientOrganizationName: null,
    purchaseOrderStatus: CapaPurchaseOrderStatus.Processing,
    serviceType: CapaQuotationServiceType.Cnc,
    paymentManageModelList: [
      {
        __typename: 'CAPAQuotationPaymentManageModel',
        thumbnailId: '1234',
        chatRoomId: '1234',
        id: v4(),
        paymentMethod: CapaPaymentMethodType.CreditCard,
        confirmedAt: '',
        createdAt: '2022-06-15',
        paidAt: '2022-06-15',
        cancelAmount: null,
        cancelId: null,
        cancelReason: null,
        cancelStatus: null,
        commission: null,
        purchaseOrderId: 'null',
        updatedAt: null,
        virtualAccountId: null,
        hasReview: false,
        isRead: false,
        quotationId: '',
        quotationPartnerId: '',
        quotationPartnerUserId: '',
        quotationUserId: '',
        rfqId: '5',
        status: CapaPaymentStatus.CancelFailed,
        totalAmount: 100000
      }
    ]
  },
  {
    __typename: 'CAPAPurchaseOrderModel',
    purchaseOrderId: v4(),
    partnerOrganizationName: 'test',
    clientOrganizationName: null,
    purchaseOrderStatus: CapaPurchaseOrderStatus.RefundRequested,
    serviceType: CapaQuotationServiceType.Cnc,
    paymentManageModelList: [
      {
        __typename: 'CAPAQuotationPaymentManageModel',
        thumbnailId: '1234',
        chatRoomId: '1234',
        id: v4(),
        paymentMethod: CapaPaymentMethodType.CreditCard,
        confirmedAt: '',
        createdAt: '2022-06-15',
        paidAt: '2022-06-15',
        cancelId: null,
        commission: null,
        purchaseOrderId: 'null',
        updatedAt: null,
        virtualAccountId: null,
        hasReview: false,
        isRead: false,
        quotationId: '',
        quotationPartnerId: '',
        quotationPartnerUserId: '',
        quotationUserId: '',
        rfqId: '6',
        status: CapaPaymentStatus.CancelFailed,
        totalAmount: 100000,
        cancelReason: '환불하고싶어서',
        cancelStatus: CapaPaymentCancelStatus.RefundRequested,
        cancelAmount: 10000
      }
    ]
  },
  {
    __typename: 'CAPAPurchaseOrderModel',
    purchaseOrderId: v4(),
    partnerOrganizationName: 'test',
    clientOrganizationName: null,
    purchaseOrderStatus: CapaPurchaseOrderStatus.RefundConfirmed,
    serviceType: CapaQuotationServiceType.Cnc,
    paymentManageModelList: [
      {
        __typename: 'CAPAQuotationPaymentManageModel',
        thumbnailId: '1234',
        chatRoomId: '1234',
        id: v4(),
        paymentMethod: CapaPaymentMethodType.CreditCard,
        confirmedAt: '',
        createdAt: '2022-06-15',
        paidAt: '2022-06-15',
        cancelAmount: null,
        cancelId: null,
        cancelReason: null,
        cancelStatus: null,
        commission: null,
        purchaseOrderId: 'null',
        updatedAt: null,
        virtualAccountId: null,
        hasReview: false,
        isRead: false,
        quotationId: '',
        quotationPartnerId: '',
        quotationPartnerUserId: '',
        quotationUserId: '',
        rfqId: '7',
        status: CapaPaymentStatus.CancelFailed,
        totalAmount: 100000
      }
    ]
  },
  {
    __typename: 'CAPAPurchaseOrderModel',
    purchaseOrderId: v4(),
    partnerOrganizationName: 'test',
    clientOrganizationName: null,
    purchaseOrderStatus: CapaPurchaseOrderStatus.Shipping,
    serviceType: CapaQuotationServiceType.Cnc,
    paymentManageModelList: [
      {
        __typename: 'CAPAQuotationPaymentManageModel',
        thumbnailId: '1234',
        chatRoomId: '1234',
        id: v4(),
        confirmedAt: '',
        createdAt: '2022-06-15',
        paidAt: '2022-06-15',
        cancelAmount: null,
        cancelId: null,
        cancelReason: null,
        cancelStatus: null,
        commission: null,
        purchaseOrderId: 'null',
        updatedAt: null,
        virtualAccountId: null,
        hasReview: false,
        isRead: false,
        quotationId: '',
        quotationPartnerId: '',
        quotationPartnerUserId: '',
        quotationUserId: '',
        rfqId: '8',
        status: CapaPaymentStatus.CancelFailed,
        totalAmount: 100000,
        paymentMethod: CapaPaymentMethodType.CreditCard
      }
    ]
  },
  {
    __typename: 'CAPAPurchaseOrderModel',
    purchaseOrderId: v4(),
    partnerOrganizationName: 'test',
    clientOrganizationName: null,
    purchaseOrderStatus: CapaPurchaseOrderStatus.PurchaseConfirmed,
    serviceType: CapaQuotationServiceType.Cnc,
    paymentManageModelList: [
      {
        __typename: 'CAPAQuotationPaymentManageModel',
        thumbnailId: '1234',
        chatRoomId: '1234',
        id: v4(),
        confirmedAt: '',
        createdAt: '2022-06-15',
        paidAt: '2022-06-15',
        cancelAmount: null,
        cancelId: null,
        cancelReason: null,
        cancelStatus: null,
        commission: null,
        purchaseOrderId: 'null',
        updatedAt: null,
        virtualAccountId: null,
        hasReview: false,
        isRead: false,
        quotationId: '',
        quotationPartnerId: '',
        quotationPartnerUserId: '',
        quotationUserId: '',
        rfqId: '9',
        status: CapaPaymentStatus.CancelFailed,
        totalAmount: 100000,
        paymentMethod: CapaPaymentMethodType.CreditCard
      }
    ]
  },
  {
    __typename: 'CAPAPurchaseOrderModel',
    purchaseOrderId: v4(),
    partnerOrganizationName: 'test',
    clientOrganizationName: null,
    purchaseOrderStatus: CapaPurchaseOrderStatus.RejectOrderByPartner,
    serviceType: CapaQuotationServiceType.Cnc,
    paymentManageModelList: [
      {
        __typename: 'CAPAQuotationPaymentManageModel',
        thumbnailId: '1234',
        chatRoomId: '1234',
        id: v4(),
        rfqId: '10',
        confirmedAt: '',
        createdAt: '2022-06-15',
        paidAt: '2022-06-15',
        cancelAmount: null,
        cancelId: null,
        commission: null,
        purchaseOrderId: 'null',
        updatedAt: null,
        virtualAccountId: null,
        hasReview: false,
        isRead: false,
        paymentMethod: CapaPaymentMethodType.CreditCard,
        quotationId: '',
        quotationPartnerId: '',
        quotationPartnerUserId: '',
        quotationUserId: '',
        status: CapaPaymentStatus.CancelFailed,
        totalAmount: 100000,
        cancelReason: '발주서 거절',
        cancelStatus: CapaPaymentCancelStatus.RejectOrderByPartner
      }
    ]
  }
];
